import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { CountryDataForm } from '../../../../app/models/Country';

type Props = {
    country: CountryDataForm;
    setCountry: (country: CountryDataForm) => void;
    errorFields?: any;
};

const CountryForm = ({ country, setCountry, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setCountry({ ...country, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Nombre</label>
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={country.name ?? ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese nombre del país"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Código</label>
                    <input
                        name="code"
                        id="code"
                        type="text"
                        className={`form-control ${fieldHasError('code')}`}
                        value={country.code ?? ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('code')}
                        placeholder="Ej: CL, AR, PE"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('code')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CountryForm;
